const courseExplorerTypes = {
    COURSE_EXPLORER_TYPE: "COURSE_EXPLORER_TYPE"
}

export { courseExplorerTypes };